module.exports = __webpack_public_path__ + "static/media/inspection-dvir.df4b99a1.svg";